import { Component, Input, OnInit, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccidentService } from 'src/app/services/accident.service';


@Component({
  selector: 'app-accident-user',
  templateUrl: './accident-user.component.html',
  styleUrls: ['./accident-user.component.scss']
})
export class AccidentUserComponent implements OnInit {

  userId: any;
  @Output() AccidentLength: EventEmitter<any> = new EventEmitter<any>();
  @Input('user') userObj;
  accidents: any;
  selectedAccident: any;
  userRole
  afterFilter: { title: string; data: string; };
  filterActive: boolean;
  userForm: any;
  selectedUser
  accidetnType: any;
  userAccident: {};
  constructor(private _accidentService: AccidentService, private activatedRoute: ActivatedRoute) {

  }

  ngOnInit() {
    const currentUser: any = JSON.parse(localStorage.getItem('currentUser'))
    console.log('currentUser', currentUser)
    // if (currentUser && currentUser.userRole.includes('incidentUser')) {
    //   this.userId = currentUser.userId
    //   // this.getAccidentByUserId()
    // }
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('Changes in accident user', changes)
    if (changes.userObj && changes.userObj.currentValue) {
      let data = changes.userObj.currentValue
      if (data.userId && data.userId._id) {
        this.selectedUser = changes.userObj.currentValue.userId._id
      } else {
        this.selectedUser = changes.userObj.currentValue.userId
      }
      this.getAccidentByUserId()
    }
  }

  // UTILITY


  singleAccident(accident) {
    // this.userForm = ''
    // this.userRole = ''
    // this.accidetnType = ''
    console.log("single accident details", accident);
    this.selectedAccident = accident._id
    let element = accident.incidentUsers.find((x) => x._id == this.userId)
    console.log("what is the element", element);
    if (element != undefined) {
      this.userAccident = {
        userRole: element.userRole,
        selectedAccident: accident._id,
        accidetnType: accident.type,
        userForm: element.userForm,
        userId: this.userId
      }

      // this.ac
    }
  }



  // API CALLS
  getAccidentByUserId() {
    this._accidentService.getAccidentByUserId(this.selectedUser).subscribe((res) => {
      console.log("res of data", res);

      let element = Object.keys(res).length
      console.log('accident list', element)
      if (element != 0) {
        this.accidents = res.accidents
        this.selectedAccident = this.accidents[0]._id
        this.userRole = res.userData.userRole
        this.userId = this.selectedUser
        this.userForm = res.userData.userForm

        this.userAccident = {
          userRole: this.userRole,
          selectedAccident: this.selectedAccident,
          accidetnType: this.accidents[0].type,
          userForm: this.userForm,
          userId: this.userId
        }
        /**
         * Accident tab
         */
        let data = {
          isAccident: true
        }

        this.AccidentLength.emit(data)
        // this._accidentService.displayAccidentTab(data)

        console.log("here call observable.......")
        // this._accidentService.displayAccidentTab({isAccident: true})
      } else {

        /**
         * Accident Tab outputinit
         */

         let data = {
          isAccident: false
        }
        this.AccidentLength.emit(data)
        // this._accidentService.displayAccidentTab({isAccident: false})




        this.afterFilter = {
          title: "No Accident!",
          data: "Sorry, no Accident assigned to you yet!"
        }
        this.filterActive = true
      }
    })
  }


  

}
